<div class="header templateBody" role="banner" *ngIf="!isCatex">
    <a class="visuallyHidden" href="#content">Skip to page content</a>

    <div class="templateContainer clear">
        <div class="siteLogo">
            <img alt="FAA seal" class="left" src="templates/4/assets/img/logoFAA.png" height="74" width="74">
            <span>IFP Environmental Pre-screening Filter</span>
        </div>

        <ul class="topNav" role="menubar" *ngIf="isLoggedIn">
            <li role="presentation">
                <a [routerLink]="['/home']" role="menuitem">Home</a>
            </li>
            <li role="presentation">
                <a [routerLink]="['/about']" role="menuitem">About</a>
            </li>
            <li role="presentation">
                <a [routerLink]="['/submissions']" role="menuitem">Submissions</a>
            </li>
            <li role="presentation" *ngIf="canAddSubmission">
                <a [routerLink]="['/addsubmission']" role="menuitem">Add Submissions</a>
            </li>
            <!-- <li role="presentation">
                <a [routerLink]="['/catex']" role="menuitem">CATEX Form</a>
            </li> -->
            <li role="presentation">
                <a [routerLink]="['/news']" role="menuitem">News</a>
            </li>
            <!-- <li role="presentation">
                <a [routerLink]="['/editsubmission', '3']" role="menuitem">FAQ</a>
            </li> -->
        </ul>

        <ul class="topNav2" *ngIf="isLoggedIn">
            <li role="presentation" *ngIf="hasAdminRights">
                <a [routerLink]="['/admin']" role="menuitem">Admin Tools</a>
            </li>
            <li role="presentation">
                <a [routerLink]="['/account']" role="menuitem">My Account</a>
            </li>
            <li role="presentation">
                <a role="menuitem" (click)="logOut()">Logout</a>
            </li>
        </ul>
    </div>
</div>